import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from './components'
import vTooltip from './directives/v-tooltip'

createApp(App).use(store).use(router).use(components).use(vTooltip).mount('#app')
